import SegmentsTable from './SegmentsTable'
export default SegmentsTable
